import { createTheme } from '@material-ui/core/styles'
import { adaptV4Theme, createTheme as createThemeV5 } from '@mui/material'
import { createMuiFromHTMLFontSize } from '@scoir/mui-theme'

const theme = createTheme(createMuiFromHTMLFontSize(16))

export const themeV5 = createThemeV5(
  adaptV4Theme({
    breakpoints: theme.breakpoints,
    palette: theme.palette,
    typography: theme.typography,
    props: {
      MuiButtonBase: {
        disableRipple: true,
      },
      MuiCard: {
        elevation: 2,
      },
    },
    overrides: {
      MuiDataGrid: {
        root: {
          border: 'none',
          '.MuiDataGrid-columnHeaderCheckbox + .MuiDataGrid-columnHeader': {
            borderLeft: 'none',
          },
          '.MuiDataGrid-cellCheckbox + .MuiDataGrid-cell': {
            borderLeft: 'none',
          },
        },
        columnSeparator: {
          color: 'transparent',
          '$root &:hover': {
            color: 'inherit',
          },
        },
        columnHeaders: {
          borderBottom: `1px solid ${theme.palette.divider}`,
          borderTop: `1px solid ${theme.palette.divider}`,
          background: '#F5F8FA',
        },
        columnHeader: {
          borderTop: `1px solid ${theme.palette.divider}`,
          borderLeft: `1px solid ${theme.palette.divider}`,
          '&:focus:not(:focus-visible)': {
            outline: 'transparent',
          },
        },
        columnHeaderCheckbox: {
          borderLeft: 'none',
        },
        footerContainer: {
          borderTop: `1px solid ${theme.palette.divider}`,
          justifyContent: 'center',
        },
        cell: {
          borderBottom: `1px solid ${theme.palette.divider}`,
          '&:focus:not(:focus-visible)': {
            outline: 'transparent',
          },
          '&--textLeft': {
            borderLeft: `1px solid ${theme.palette.divider}`,
          },
        },
        cellCheckbox: {
          borderLeft: 'none',
        },
      },
      MuiTablePagination: {
        selectLabel: {
          margin: '0px',
        },
        displayedRows: {
          margin: '0px',
        },
      },
    },
  }),
)

export default theme
